module.exports = __webpack_public_path__ + "img/hdfcbank.6d0f4e35.jpg";